module.exports = __webpack_public_path__ + "37c00a782d3a08d67cf3952ecb6d1c96.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/picture/Canucks_0.jpg
// module id = 370
// module chunks = 0